/* eslint-disable global-require,import/no-unresolved,react/destructuring-assignment,react/prop-types */
import React, { Component } from 'react'
import { ScrollView, Text, View } from 'react-native'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styles, { colors } from '../../styles'
import { gotoSubPage } from '../../actions/helpers'
import SimpleMenuListItem from '../subcomponents/SimpleMenuListItem'
import * as tapEvents from '../../actions/tapEvents'
import listMenuItemStyles from '../../styles/listMenuItem'

class FAQMonitoringSystemPage extends Component {
  tapFAQItem = async (title, id) => {
    this.props.faqItemTapped(title, id)
  }

  render() {
    const { t } = this.props
    return (
      <View accessibilityLabel={t('access:faqMonitoringSystemList')} testID="view-FAQListPage" style={[styles.container, { backgroundColor: colors.raven_grey10 }]}>
        <ScrollView
          testID="scrollview-FAQMonitoringSystemPage"
        >
          <View style={{
 flex: 1, flexDirection: 'column', alignItems: 'center',
}}
          >
            <Text style={listMenuItemStyles.sectionTextHeader}>
              {t('yourMonitoringSystem')}
            </Text>
          </View>
          <SimpleMenuListItem
            t={t}
            titleKey="faq:whatIsCommunicator"
            testID="faqbtn-communicator"
            onPress={() => {
              this.tapFAQItem('whatIsCommunicator', 'communicator')
            }}
          />
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="howDoISetUp"
            testID="faqbtn-communicator-setup"
            onPress={() => gotoSubPage('CommunicatorSetupStack', 'howDoISetup')}
          />
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="howKnowCommunicatorWorking"
            testID="faqbtn-communicator-working"
            onPress={() => this.tapFAQItem('howKnowCommunicatorWorking', 'communicatorWorking')}
          />
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="faq:whatIsRemoteMonitoring"
            testID="faqbtn-remote-monitoring"
            onPress={() => this.tapFAQItem('whatIsRemoteMonitoring', 'remoteMonitoring')}
          />
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="faq:whatIsRemoteSchedFollowup"
            testID="faqbtn-remote-followup"
            onPress={() => this.tapFAQItem('whatIsRemoteSchedFollowup', 'remoteFollowup')}
          />
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="manuallyTransmitDataTitle"
            testID="faqbtn-manual-transmit"
            onPress={() => this.tapFAQItem('manuallyTransmitDataTitle', 'manualTransmit')}
          />
        </ScrollView>
      </View>
    )
  }
}

FAQMonitoringSystemPage.propTypes = {
  faqItemTapped: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const actionCreators = {
  faqItemTapped: tapEvents.faqItemTapped,
}

export const FAQMonitoringSystemPageComponent = FAQMonitoringSystemPage

export default withTranslation(['faq', 'common'])(connect(null, actionCreators)(FAQMonitoringSystemPage))
